import React from "react";
import PropTypes from "prop-types";

import styles from "./Button.module.css";

const UIButtonPrimary = ({ className, children, ...nativeProps }) => {
  const loaderBtn =
    nativeProps.isloading === "true" ? (
      <div className={styles.btnLoader} />
    ) : null;
  return (
    <button {...nativeProps} className={`${styles.primary} ${className}`}>
      <div className={styles.buttonContent}>
        {loaderBtn}
        <div className={styles.buttonText} id={`label_${children}`}>{children}</div>
      </div>
    </button>
  );
};

UIButtonPrimary.propTypes = {
  className: PropTypes.string
};

export default UIButtonPrimary;
